"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Alerts = exports.AlertsWithoutState = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_redux_1 = require("react-redux");
const Redux_1 = require("../Redux");
const AlertsList_1 = require("./AlertsList");
const AlertsWithoutState = (props) => {
    const { alerts, dispatch } = props;
    const alertKeys = Object.keys(props.alerts);
    const hasAlerts = alertKeys.some((key) => alerts[key].length > 0);
    return hasAlerts ? ((0, jsx_runtime_1.jsx)("div", { className: "alerts-wrap", children: alertKeys.map((key, index) => {
            const alertCategory = alerts[key];
            return alertCategory && alertCategory.length > 0 ? ((0, jsx_runtime_1.jsx)(AlertsList_1.AlertsList, { alerts: alertCategory, alertType: key, dispatch: dispatch }, `alert_${key}_${index}`)) : null;
        }) }, void 0)) : null;
};
exports.AlertsWithoutState = AlertsWithoutState;
exports.Alerts = (0, react_redux_1.connect)((state) => ({
    [Redux_1.PublicRequestKeys.Alerts]: state[Redux_1.PublicRequestKeys.Alerts],
}))(exports.AlertsWithoutState);
exports.default = exports.Alerts;
